"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("react-id-swiper/src/styles/css/swiper.css");
exports.default = require('react-id-swiper').default;
